define([
    '../Util/defaultValue',
    '../Util/defined',
    '../Util/encode',
    '../Util/callbackSystem',
    '../System/Vec3Obj'
], function (
    defaultValue,
    defined,
    encode,
    callbackSystem,
    Vec3Obj
) {
    'use strict'
    Element.prototype.PickerInstance = null
    var Picker = (() => {
        return function (props, pickCallback, editCallback) {
            if (Element.prototype.PickerInstance) {
                return Element.prototype.PickerInstance
            }
            return Element.prototype.PickerInstance = new PickerSingleton(props, pickCallback, editCallback)
        }
    })()
    /**
     * 拾取器单例。
     * 
     * @demo {@link http://lbs.zjkelan.com/Picker.html|CooWasm Picker demo}
     * @alias Picker
     * @constructor
     *
     * @param {Object} props 包含如下属性的Object：
     * @param {Boolean} [props.bActive=true] 拾取器激活状态。
     * @param {Boolean} [props.bDrag=false] 拾取后是否拖拽编辑,pickCallback设置后生效。
     * @param {CallbackString} [pickCallback=null] 拾取成功后触发的函数回调。
     * @param {CallbackBoolean} [editCallback=null] 编辑成功后触发的函数回调。
     * @example
     * var picker = new CooWasm.Picker({},(state)=>{console.log("load status:" + state)})
     */
    class PickerSingleton {
        /**
         * @description 拾取器激活状态。
         * @type {Boolean}
         * @default true
         */
        bActive
        /**
         * @description 拾取后是否拖拽编辑。
         * @type {Boolean}
         * @default false
         */
        bDrag
        /**
         * @description 拾取对象的uuid。
         * @type {String}
         * @readonly
        */
        pickedId
        /**
         * @description GeoCuboid在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "Picker"
        static avatarType = null
        static componentType = null

        constructor(props, pickCallback, editCallback) {
            if (!defined(props)) {
                props = {}
            }
            this.bActive = defaultValue(props.bActive, true)
            this.bDrag = defaultValue(props.bDrag, false)
            callbackSystem.register("", "PickObject", (uuid) => {
                this.pickedId = uuid
                if (defined(pickCallback)) {
                    if (this.bDrag) {
                        Element.prototype.NativeAPI.SetDraggerObject(encode(uuid))
                    }
                    pickCallback(uuid)
                }
            })
            callbackSystem.register("", "Drag", (state) => {
                if (defined(editCallback)) {
                    editCallback(state)
                }
            })
            Element.prototype.NativeAPI.EnablePicker(this.bActive, this.bDrag)
        }

        /**
         * <p>
         * 更新单个或者多个对象属性，使之立即生效。
         * </p>
         *
         * @param {Object} [props] 包含如下属性的Object。
         * @param {Boolean} [props.bActive] 拾取器激活状态。
         * @param {Boolean} [props.bDrag] 拾取后是否拖拽编辑。
         * @param {CallbackString} [pickCallback=null] 拾取成功后触发的函数回调。
         * @param {CallbackBoolean} [editCallback=null] 编辑成功后触发的函数回调。
         * @example
         * picker.update({
         *    bVisible:false
         * },(state)=>{console.log("update status:" + state)})
         */
        update(props, pickCallback, editCallback) {
            this.bActive = defaultValue(props.bActive, this.bActive)
            this.bDrag = defaultValue(props.bDrag, this.bDrag)
            callbackSystem.register("", "PickObject", (uuid) => {
                if (defined(pickCallback)) {
                    if (this.bDrag) {
                        Element.prototype.NativeAPI.SetDraggerObject(encode(uuid))
                    }
                    pickCallback(uuid)
                }
            })
            callbackSystem.register("", "Drag", (state) => {
                if (defined(editCallback)) {
                    editCallback(state)
                }
            })
            Element.prototype.NativeAPI.EnablePicker(this.bActive, this.bDrag)
        }

        /**
         * 获取对象包含的属性。
         * @returns {Object} 是否获取成功。获取成功时，会自动赋值给属性。
         * @example
         * picker.getProperties()
         */
        getObject() {
            if (!defined(this.pickedId)) {
                console.log("no picked object!")
                return null
            }
            //
            let obj = Element.prototype.Map.models.find(item => item.avatarUuid === this.pickedId)
            if(obj === undefined || obj === null){
                obj = Element.prototype.Map.labels.find(item => item.avatarUuid === this.pickedId)
                if (obj === undefined || obj === null) {
                    obj = Element.prototype.Map.geoCuboids.find(item => item.avatarUuid === this.pickedId)
                    if (obj === undefined || obj === null) {
                        obj = Element.prototype.Map.geoSpheres.find(item => item.avatarUuid === this.pickedId)
                    }
                }
            }
            return obj
        }
        /**
         * 重置拾取器。
         * @example
         * picker.reset()
         */
        reset() {
            this.pickedId = null
            Element.prototype.NativeAPI.ResetPicker()
        }
        /**
         * 关闭拾取器。
         * @returns null 空值。
         * @example
         * picker = picker.destroy((state)=>{console.log("destroy status:" + state)})
         */
        destroy() {
            this.bActive = false
            this.bDrag = false
            this.pickedId = null
            Element.prototype.NativeAPI.EnablePicker(false, false)
            Element.prototype.NativeAPI.SetDraggerObject(encode(""))
            callbackSystem.remove("", "PickObject") 
            callbackSystem.remove("", "Drag") 
            Element.prototype.PickerInstance = null
            return null
        }
    }
    return Picker
})